export const CommonMenuConfig: MenuItem[] = [

]
